import { FileType } from 'enums';
import { Submission } from 'types';
import { HttpMethods } from 'utils/http';
import { CapitolaClient } from './base';

interface SalesDemo {}

export interface ClearSubmissionData {
  submissionId: string;
}

export class SalesDemoClient extends CapitolaClient<SalesDemo> {
  public get resourceName(): string {
    return 'sales-demo';
  }

  public async clearSubmission(data: ClearSubmissionData): Promise<Submission | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'clear-submission',
      body: { ...data },
      fetchOptions: { throwOnError: true },
    });
  }

  public async fetchFromAMS(submissionId: string): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'renewal/fetch-from-ams',
      body: { submissionId },
      fetchOptions: { throwOnError: true },
    });
  }

  public async marketViaAPI(submissionId: string): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'renewal/market-via-api',
      body: { submissionId },
      fetchOptions: { throwOnError: true },
    });
  }

  public async marketViaEmail(submissionId: string): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'renewal/market-via-email',
      body: { submissionId },
      fetchOptions: { throwOnError: true },
    });
  }

  public async marketViaPortal(submissionId: string): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'renewal/market-via-portal',
      body: { submissionId },
      fetchOptions: { throwOnError: true },
    });
  }

  public async receiveQuotes(
    submissionId: string,
    quoteType?: FileType.MarketQuote | FileType.RenewalPolicy,
  ): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'renewal/receive-quotes',
      body: { submissionId, quoteType },
      fetchOptions: { throwOnError: true },
    });
  }

  public async createProposal(submissionId: string): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'renewal/create-proposal',
      body: { submissionId },
      fetchOptions: { throwOnError: true },
    });
  }

  public async writeToAMS(submissionId: string): Promise<void | null> {
    return this.custom({
      httpMethod: HttpMethods.POST,
      path: 'renewal/write-to-ams',
      body: { submissionId },
      fetchOptions: { throwOnError: true },
    });
  }
}
